import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, MOCKUP_ALT, OFFER_NAME, offerItems, pricing } from '../data/sushiContent';
export function OfferSection() {
  return <section id="offer" className="w-full border-y border-champagne/25 bg-black py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-202" data-mp="dfgax613w0cy">
      <div className="mx-auto max-w-4xl px-5" data-id="element-203" data-mp="meabt8lgzcwb">
        <div className="border border-champagne/30 bg-charcoal-950 px-5 py-6 text-center sm:px-8" data-id="element-204" data-mp="md0e4kij46q7">
          <CountdownTimer label="Precio de lanzamiento cierra en" size="lg" data-id="element-205" data-mp="repn7um6yabn" />
          <p className="mt-4 flex items-center justify-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-rose" data-id="element-206" data-mp="wbok2kx8ovdj">
            <AlertTriangleIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-207" data-mp="2t7dtkcu4tdvn" />
            Después sube a {pricing.afterLaunch}. No vuelve.
          </p>

          <div className="mx-auto mt-6 max-w-sm" data-id="element-208" data-mp="12oa80txae5ip">
            <div className="flex items-baseline justify-between text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-209" data-mp="xws4by3vpqu1">
              <span data-id="element-210" data-mp="swxdfuk3t18z">Cupos con precio de lanzamiento</span>
              <span className="text-champagne" data-id="element-211" data-mp="svcockgk6aii">{pricing.spotsTaken}% ya tomados</span>
            </div>
            <div className="mt-2 h-1 w-full overflow-hidden bg-charcoal-700" role="img" aria-label={`${pricing.spotsTaken} por ciento de los cupos con precio de lanzamiento ya tomados`} data-id="element-212" data-mp="1lme4ans2sa33">
              <div className="h-full bg-champagne" style={{
              width: `${pricing.spotsTaken}%`
            }} data-id="element-213" data-mp="1ckn2vv4kipf1" />
            </div>
          </div>
        </div>

        <h2 id="offer-title" className="mt-12 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-214" data-mp="16sxc83dn0dk">
          Tu acceso completo
        </h2>

        <div className="mt-8 grid items-center gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-215" data-mp="3tuiycsebxeme">
          <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto w-full max-w-sm sm:max-w-none" width={1536} height={1024} data-id="element-216" data-mp="2mn6nhq4lf2h" />

          <div data-id="element-217" data-mp="3otv6k4ia0tr4">
            <p className="font-display text-xl font-semibold uppercase leading-tight text-ivory-50" data-id="element-218" data-mp="3otbrcvk0gjgs">
              {OFFER_NAME}
            </p>
            <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-219" data-mp="3ftygbyg8nmty">
              Ideal para: {pricing.idealFor}
            </p>

            <ul className="mt-5 space-y-2 border-t border-charcoal-600 pt-5" data-id="element-220" data-mp="3175arkwitvey">
              {offerItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-221" data-mp="3622eqdey1ekz">
                  <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-222" data-mp="2s55p2faka35o" />
                  <span className="text-[14px] leading-snug text-ivory-100" data-id="element-223" data-mp="2digsal7p242z">{item}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-[12px] uppercase tracking-[0.12em] text-muted line-through" data-id="element-224" data-mp="2min0psojcdva">
              Precio regular: {pricing.regularPrice}
            </p>
            <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-225" data-mp="2ifqgxyn9ebpr">
              {pricing.today}
              <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-226" data-mp="2rhznkdfepkxv">
                USD
              </span>
            </p>

            <div className="mt-6" data-id="element-227" data-mp="368fbhzz7j6zq">
              <CtaButton target="checkout" size="md" label="Quiero acceso AHORA →" data-id="element-228" data-mp="3179gtwlzl9nk" />
            </div>
            <TrustStrip className="mt-3 sm:justify-start" data-id="element-229" data-mp="3f6j0j69eilwa" />
          </div>
        </div>
      </div>
    </section>;
}